<script>
  export default {
    mounted() {
        this.$root.botaoAcaoMostrar = true;
    }
  }
</script>

<template>
  <router-view></router-view>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/Relatorio.vue